import { Box, Spacer, Text, TextInput } from '@jfs/ui-new'
import { useIsFocused } from '@react-navigation/native'
import { FC, useEffect, useRef, useState } from 'react';
import { InteractionManager, Keyboard } from 'react-native'
import { isOsMobile } from '../../util/utill'
import { useKeyboard } from '../KeyboardAwareModal/keyboardHook'
import styles from './styles'
import { TextInputProps } from './types'

const CODE_LENGTH = new Array(6).fill(0)

const OtpTextInput: FC<TextInputProps> = (props: TextInputProps) => {
  const isFocused = useIsFocused()

  const OtpInput = useRef<TextInputProps>(null)

  const [focused, setFocused] = useState(true)
  const value = props?.value ?? ''
  const [keyboardHeight] = useKeyboard()

  const handleFocus = () => {
    setFocused(true)
  }
  const handleBlur = () => {
    isOsMobile() && setFocused(false)
    Keyboard.dismiss()
    if (props.onBlur) {
      props.onBlur()
    }
  }

  useEffect(() => {
    // Must run after animations for keyboard to automatically open
    if (isFocused) {
      InteractionManager.runAfterInteractions(() => {
        if (OtpInput?.current) {
          OtpInput?.current?.focus()
        }
      })
    }
  }, [isFocused, keyboardHeight])

  const handleKeyPress = (e: any) => {
    if (e.nativeEvent.key === 'Backspace' || e.key === 'Backspace') {
      handleFocus()
      if (props.setFieldValue && props.fieldName) {
        props.setFieldValue(props.fieldName, value.slice(0, value.length - 1))
      }
    }
  }
  const handleChange = (text: string) => {
    if (value.length < CODE_LENGTH.length) {
      handleFocus()
      if (value.length === CODE_LENGTH.length - 1) {
        handleBlur()
      }
      if (props.setFieldValue && props.fieldName) {
        props.setFieldValue(props.fieldName, (value + text).slice(0, CODE_LENGTH.length))
      }
    }
  }
  const isError = props.error && !focused && value?.length < 6
  const errorStyle = isError ? styles.error : {}
  const values = value.split('')

  const textBox = CODE_LENGTH.map((v, index) => {
    const selected = values.length === index
    const filled = values.length === CODE_LENGTH.length && index === CODE_LENGTH.length - 1
    const getTextView = () => {
      if (!values[index]) {
        return <Text type={'h2'}>{''}</Text>
      }
      return <Text type={'h2'}>{values[index]}</Text>
    }
    const highlightBottom = (selected || filled) && focused
    const content = getTextView()
    return (
      <Box {...styles.display(highlightBottom)} {...errorStyle} key={index} underlayColor="TRANSPARENT">
        {content}
      </Box>
    )
  })

  return (
    <Box {...styles.container} onPress={() => OtpInput?.current?.focus()} underlayColor="TRANSPARENT">
      <Box {...styles.subContainer}>
        <Box {...styles.wrap} underlayColor="TRANSPARENT">
          <Box {...styles.input}>
            <TextInput
              testID="pin-input"
              accessibilityLabel="pin-input"
              nativeID="pin-input"
              value=""
              {...styles.input}
              caretHidden={true}
              onChangeText={handleChange}
              onKeyPress={handleKeyPress}
              onFocus={handleFocus}
              onBlur={() => handleBlur()}
              autoFocus={true}
              keyboardType="numeric"
              onFocusBottomLineColor="TRANSPARENT"
              showBottomLine={false}
              maxLength={6}
              innerRef={OtpInput}
              returnKeyType={value?.length > 5 ? 'done' : 'next'}
            />
          </Box>
          {textBox}
        </Box>
        <Spacer size={10} direction="horizontal" />
        {props.rightView}
      </Box>
      <Box w={'100%'} height={35} pt={12}>
        {isError && (
          <Text type={'caption'} textAlign="left" color="ERROR" numberOfLines={1}>
            {props.error}
          </Text>
        )}
      </Box>
    </Box>
  )
}

export { OtpTextInput }
